import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Divider, Button } from "@material-ui/core";
import "moment-timezone";
import TabHeader from "src/components/TabHeader/TabHeader";
import { YardRoute } from "../../yard.routes";
import { useStyles } from "./components/style";
import { YardContainer } from "./components/YardContainer";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { Backdrop } from "@mui/material";
import {
  getYardRowsSlotsAction,
  getActiveAllYardsListingAction,
  getYardTrail,
} from "src/app-redux/yard/actions/yardActions";

import {
  loader,
  addYardId,
  selectAllYardsListing,
  flushComponentRecord,
  selectComponentYardId,
  addComponentYardId,
  addVehicleId,
  drawerOpenedFor,
  setYardRowSlots,
  selectYardRowsSlots,
} from "src/app-redux/yard/yardSlice";
import CachedIcon from "@material-ui/icons/Cached";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import Drawer from "./components/Drawer";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import moment from "moment";
import { mkConfig, generateCsv, download } from "export-to-csv";
import DownloadIcon from "@mui/icons-material/Download";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { minutesToDhms } from "./components/VehicleImages";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function Listing({}: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const moduleName = YardRoute.title;
  const pageHeading = "Yard";
  const componentYardId = useAppSelector(selectComponentYardId);
  const loading = useAppSelector(loader);
  const allYards: any = useAppSelector(selectAllYardsListing);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [selectedVehicle, setSelectedVehicle] = React.useState<string>("");
  const [vehicleLoader, setVehicleLoader] = useState<any>(false);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const rowsRecord = useAppSelector(selectYardRowsSlots);
  const [yardName, setYardName] = useState("");
  useEffect(() => {
    if (allYards.length !== 0) {
      dispatch(getYardRowsSlotsAction(allYards[0].id));
      dispatch(addYardId(allYards[0].id));
      dispatch(addComponentYardId(allYards[0].id));
    } else {
      dispatch(setYardRowSlots([]));
    }
  }, [allYards]);
  const refreshPage = () => {
    dispatch(getYardRowsSlotsAction(componentYardId));
    setSelectedVehicle("");
    setvehicleRegNumberArr([]);
  };
  useEffect(() => {
    refreshPage();
    dispatch(getActiveAllYardsListingAction());
    return () => {
      dispatch(flushComponentRecord());
    };
  }, []);

  const handleYardChange = (id: number) => {
    dispatch(addComponentYardId(id));
    dispatch(addYardId(id));
    dispatch(getYardRowsSlotsAction(id));
  };

  /* AXIOS Calls */
  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };
  const getVehicleInfoByVehicleId = async (id: number, title: string) => {
    let results: any = [];
    try {
      setVehicleLoader(true);
      // Add API here
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
      setVehicleLoader(false);
      return;
    } catch (error: any) {
      setVehicleLoader(false);
    }
  };
  /*./AXIOS Calls */

  const handleVehicleChange = async (gatePassId: any, vehicleId: any) => {
    if (gatePassId && vehicleId) {
      await dispatch(getVehicleDetailsByIdAction(gatePassId));
      await dispatch(getYardTrail(vehicleId));
      dispatch(setSelectedVehicleId(gatePassId));
      dispatch(addVehicleId(vehicleId));
      dispatch(drawerOpenedFor("vehicleNumber"));
      setisDrawerOpen(true);
    }
  };

  const handleCloseDrawer = () => {
    setvehicleRegNumberArr([]);
    setSelectedVehicle("");
    dispatch(setSelectedVehicleId(""));
    dispatch(addVehicleId(""));
    setisDrawerOpen(false);
  };

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    filename: "Yard",
  });

  const filterExportData = () => {
    const yard = yardName
      ? allYards.find((st: any) => st.id === yardName)?.name
      : allYards[0]?.name;

    const result = rowsRecord
      .filter((data: any) => data.noOfVehicles > 0)
      .flatMap((row: any) =>
        row.slots
          .filter((rec: any) => rec.vehicle)
          .map((slot: any) => ({
            Yard: yard,
            Row: `Row ${row.rowName}`,
            Slot: slot.slotOrder,
            "Vehicle No": slot.vehicle.vehicleRegistration,
            "Entry date": moment(new Date(slot.vehicle.yardDateTime)).format("DD/MM/YYYY hh:mm a"),
            "Vehicle Status": slot.vehicle?.vehicleStatus,
            "Consignment Type": slot.vehicle?.consignmentType,
            Cargo: slot.vehicle.cargoType,
            "Yard stay time": minutesToDhms(slot?.vehicle?.vehicleInYardMinutes),
          }))
      );
    return result;
  };
  const handleExportData = async () => {
    const result = await filterExportData();
    if (result) {
      dispatch(
        addNotificationAction({
          message: "Your download will begin shortly",
          options: { variant: "success" },
        })
      );
      const csv = generateCsv(csvConfig)(result);
      download(csvConfig)(csv);
    }
  };

  useEffect(() => {
    filterExportData();
  }, [rowsRecord]);

  return (
    <>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Backdrop className={classes.backdrop} open={loading || vehicleLoader}>
        <CommonLoader />
      </Backdrop>

      <TabHeader module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: "auto" }}>
          <Grid container direction="row" justifyContent="space-between">
            <Grid xs={11} md={3}>
              <Box mt={1} mb={2}>
                <Grid item md={12}>
                  <Box>
                    <CommonAutoCompleteField
                      cssClassName="customTextField"
                      label="Yard Name"
                      placeholder="Select Yard Name"
                      name="yardId"
                      disableClearable={true}
                      optionsType={allYards}
                      getOptionLabel={(option) => option.name}
                      required
                      value={allYards.find((st: any) => st.id === componentYardId) || null}
                      onChange={(option: any) => {
                        if (option && option.name !== "" && option.id !== 0) {
                          setYardName(option.id);
                          handleYardChange(option.id);
                        }
                      }}
                    />
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid xs={1} md={6}>
              <span className={classes.refreshIcon}>
                <CachedIcon
                  onClick={() => {
                    refreshPage();
                  }}
                />

                <Button
                  style={{ marginLeft: "10px" }}
                  // variant="contained"
                  disabled={isExport && filterExportData().length == 0}
                  onClick={() => handleExportData()}
                  startIcon={<DownloadIcon />}
                >
                  Export data to Excel
                </Button>
              </span>
            </Grid>

            <Grid xs={12} md={3}>
              <Box mt={1} mb={2}>
                <Grid item md={12}>
                  <Box>
                    <CommonAutoCompleteField
                      cssClassName="customTextField"
                      label="Vehicle Number"
                      placeholder="Enter Vehicle Number"
                      name="registrationNumber"
                      optionsType={vehicleRegNumberArr}
                      getOptionLabel={(option) => option.registrationNumber}
                      value={
                        vehicleRegNumberArr.find((st: any) => st.vehicleId === selectedVehicle) ||
                        null
                      }
                      onChange={async (option: any) => {
                        if (option && option.registrationNumber !== "" && option.vehicleId !== 0) {
                          await getVehicleInfoByVehicleId(
                            option.vehicleId,
                            option.registrationNumber
                          );
                          setSelectedVehicle(option.vehicleId);
                          handleVehicleChange(option.gatePassId, option.vehicleId);
                        } else {
                          setSelectedVehicle("");
                          handleVehicleChange(null, null);
                        }
                      }}
                      onKeyUp={(e: any) => {
                        setVehicleNumberLength(e.target.value.length);
                        if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                          getVehicleByRegistrationNo(e.target.value);
                          return;
                        }
                      }}
                      onKeyDownCapture={(e: any) => {
                        if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      }}
                      onPaste={(e: any) => {
                        if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                          e.preventDefault();
                          return;
                        }

                        if (e.clipboardData.getData("text").length >= 2)
                          getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                      }}
                    />
                  </Box>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <YardContainer yardId={componentYardId} />
        </CardContent>
      </Card>
    </>
  );
}
